import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { rankingApi, type Rankings } from '@/services/api';

const COLS: { key: keyof Rankings; title: string }[] = [
  { key: 'hotProjects', title: '热门项目' },
  { key: 'hotUsers', title: '热门企业' },
  { key: 'activeBuyers', title: '最活跃买家' },
  { key: 'topRated', title: '高分用户' },
];

export default function RankingBoard() {
  const [data, setData] = useState<Rankings | null>(null);

  useEffect(() => {
    rankingApi.get().then(setData).catch(() => {});
  }, []);

  if (!data) return null;

  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-12">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
            平台榜单
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {COLS.map((col) => (
            <div key={col.key} className="bg-background-50 rounded-lg p-6">
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-4">{col.title}</h3>
              <ol className="flex flex-col gap-3">
                {(data[col.key] ?? []).slice(0, 5).map((it, i) => {
                  const inner = (
                    <div className="flex items-center gap-3">
                      <span className="w-6 h-6 shrink-0 rounded-full bg-primary-500 text-background-50 text-xs flex items-center justify-center">
                        {i + 1}
                      </span>
                      <div className="min-w-0">
                        <p className="text-sm text-foreground-800 truncate">{it.company || '—'}</p>
                        <p className="text-xs text-foreground-400 truncate">
                          {col.key === 'topRated'
                            ? `${(it.ratingAvg ?? 0).toFixed(1)} 分 · ${it.ratingCount ?? 0} 评`
                            : `${it.region || ''}${it.count != null ? ` · ${it.count}` : ''}`}
                        </p>
                      </div>
                    </div>
                  );
                  if (col.key === 'hotProjects') {
                    return (
                      <li key={`${it.type}-${it.id}`}>
                        <Link to={`/detail/${it.type}/${it.id}`} className="block hover:opacity-80">
                          {inner}
                        </Link>
                      </li>
                    );
                  }
                  return (
                    <li key={it.id}>
                      <Link to={`/u/${it.id}`} className="block hover:opacity-80">
                        {inner}
                      </Link>
                    </li>
                  );
                })}
                {(data[col.key] ?? []).length === 0 && (
                  <li className="text-xs text-foreground-400">暂无数据</li>
                )}
              </ol>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
